import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'smartControl_page',
  components: {
    labSel: function labSel() {
      return import('../../org/lab_sel.vue');
    },
    areaSel: function areaSel() {
      return import('../../org/lab_area_sel.vue');
    },
    videoSel: function videoSel() {
      return import('../video/video_sel.vue');
    },
    dotBmap: function dotBmap() {
      return import('@/components/dotBmap.vue');
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '控制器管理',
        addFunName: 'smartControlAdd',
        modifyFunName: 'smartControlModify',
        queryFunName: 'smartControlQuery',
        detailFunName: 'smartControlDetail',
        delFunName: 'smartControlDel',
        dicTreeFunName: 'dictionaryCache'
      },
      searchForm: {
        page: 1,
        limit: 6,
        searchKey: null,
        sortField: 'online_state,lab_id,id',
        type: 'SC_Collector'
      },
      formData: {
        comModel: 'DTU',
        interactiveModel: 'Ask_Report',
        offlineThreshold: 600,
        geoMode: 'Cloud',
        type: 'SC_Collector'
      },
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        id: [{
          required: true,
          message: '请输入控制器编号',
          trigger: 'blur'
        }, {
          min: 6,
          message: '至少输入6位字符',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择类型',
          trigger: 'blur'
        }],
        interactiveModel: [{
          required: true,
          message: '请选择通信模式',
          trigger: 'blur'
        }],
        comModel: [{
          required: true,
          message: '请选择通讯模式',
          trigger: 'blur'
        }],
        labId: [{
          required: true,
          message: '请选择企业机构',
          trigger: 'blur'
        }],
        areaId: [{
          required: true,
          message: '请选择养殖区域',
          trigger: 'blur'
        }],
        model: [{
          required: true,
          message: '请输入型号',
          trigger: 'blur'
        }],
        offlineThreshold: [{
          required: true,
          message: '请输入离线阈值',
          trigger: 'blur'
        }],
        storageInterval: [{
          required: true,
          message: '请输入存储间隔',
          trigger: 'blur'
        }],
        protocolVersion: [{
          required: true,
          message: '请输入协议版本',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {},
      lab_show: false,
      area_show: false,
      dicData: {
        typeUpperCode: 'smart_control_type',
        configTypes: [],
        configTypeOptions: {},
        versionUpperCode: 'Device_Protocol',
        configVersions: [],
        configVersionOptions: {}
      },
      geoMode: {
        Device: '设备',
        Cloud: '云端'
      },
      isBusiness: localStorage.getItem('accountCategory') === 'Business' ? true : false,
      videoSel_show: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.typeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configTypes = res.data;
          var _iterator = _createForOfIteratorHelper(res.data),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              _this.dicData.configTypeOptions[item.code] = item;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.versionUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configVersions = res.data;
          var _iterator2 = _createForOfIteratorHelper(res.data),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              _this.dicData.configVersionOptions[item.code] = item.name;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          _this.formData.protocolVersion = res.data[0].code;
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.emptyFormData = JSON.parse(JSON.stringify(_this.formData));
      _this.query();
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'del':
          // 删除
          this.del(command.row.id);
          break;
        case 'askCmd':
          // 询问命令
          this.askCmd(command.row);
          break;
        case 'item':
          // 检测参数
          this.item(command.row);
          break;
        case 'warn':
          // 设备规则
          this.warn(command.row);
          break;
        case 'logs':
          // 活动日志
          this.logs(command.row);
          break;
        case 'task':
          // 定时任务
          this.task(command.row);
          break;
        case 'edit':
          // 设备编辑
          this.edit(command.row);
          break;
      }
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.initFormData(this.emptyFormData);
      this.editDialogShow = true;
    },
    edit: function edit(_ref) {
      var _this2 = this;
      var id = _ref.id,
        labName = _ref.labName,
        areaName = _ref.areaName;
      // this.initFormData(data)
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        if (res.data) {
          _this2.initFormData(_objectSpread(_objectSpread({}, res.data), {}, {
            labName: labName,
            areaName: areaName
          }));
          _this2.editDialogTitle = _this2.pageConfig.editPageName + '维护';
          _this2.editDialogShow = true;
        }
      });
    },
    getLocation: function getLocation(_ref2) {
      var point = _ref2.point;
      this.$set(this.formData, 'geoLng', point.lng);
      this.$set(this.formData, 'geoLat', point.lat);
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
        this.$set(this.formData, 'areaId', '');
        this.$set(this.formData, 'areaName', '');
      }
      this.lab_show = false;
    } // 选择养殖区域
    ,
    areaSel: function areaSel(data) {
      if (data) {
        this.$set(this.formData, 'areaId', data.id);
        this.$set(this.formData, 'areaName', data.name);
      }
      this.area_show = false;
    } // 选择监控设备
    ,
    videoClick: function videoClick() {
      if (!this.formData.labId) {
        this.$message.info('请先选择所属企业！');
        return;
      }
      this.videoSel_show = true;
    },
    videoSel: function videoSel(data) {
      if (data) {
        this.$set(this.formData, 'showVideoId', data.id);
        this.$set(this.formData, 'showVideoName', data.videoName);
      }
      this.videoSel_show = false;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref3) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref3.file;
              _this3.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  var icon;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this3.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        icon = _context.sent;
                        _this3.$set(_this3.formData, 'icon', icon);
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.icon);
    },
    removeFile: function removeFile() {
      this.formData.icon = '';
    },
    del: function del(id) {
      var _this4 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this4.$api[_this4.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this4.$message.success('删除成功');
            _this4.query();
          } else {
            _this4.$message.error('删除失败');
          }
        });
      });
    } // 参数
    ,
    item: function item(course) {
      this.$emit('child-go', course, 'smartControlItem');
    } // 告警规则
    ,
    warn: function warn(course) {
      console.log('告警规则!!!!!!!!!!!', course);
      this.$emit('child-go', course, 'smartControlRule');
    } // 历史记录
    ,
    history: function history(course) {
      this.$emit('child-go', course, 'smartControlTLog');
    } // 告警历史
    ,
    warnHistory: function warnHistory(course) {
      this.$emit('child-go', course, 'smartControlWarnLog');
    } // 历史分析
    ,
    analysis: function analysis(course) {
      this.$emit('child-go', course, 'smartControlTLogAnalysis');
    } // 询问命令
    ,
    askCmd: function askCmd(course) {
      this.$emit('child-go', course, 'smartControlCmd');
    } // 活动日志
    ,
    logs: function logs(course) {
      this.$emit('child-go', course, 'smartControlLog');
    } // 定时任务
    ,
    task: function task(course) {
      this.$emit('child-go', course, 'smartControlTask');
    },
    query: function query() {
      var _this5 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this5.tableData = res.data || [];
        _this5.totalCount = res.count;
        _this5.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this6 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this6.formData.createTime) {
            _this6.$api[_this6.pageConfig.modifyFunName](_this6.saveFormDataProcess(_this6.formData)).then(function (res) {
              if (res.data) {
                _this6.$message.success('编辑成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('编辑失败');
              }
            });
          } else {
            _this6.$api[_this6.pageConfig.addFunName](_this6.saveFormDataProcess(_this6.formData)).then(function (res) {
              if (res.data) {
                _this6.$message.success('新增成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'online_state, id';
      this.query();
    }
  }
};